import { createStore } from 'vuex';
import { auth } from './auth';
import { printList } from './printList';

// Root store: snackbar/flash-message plumbing + the auth module.
// Structured so new domain modules (additions, deeds, docs, etc.) can be
// added the same way `auth` was, as this app grows past scaffolding.
export default createStore({
  modules: {
    auth,
    printList,
  },
  state: {
    snackbar: {
      show: false,
      color: '',
      text: '',
    },
  },
  mutations: {
    setSnackbar(state, { color, text }) {
      state.snackbar = { show: true, color, text };
    },
    closeSnackbar(state) {
      state.snackbar.show = false;
    },
  },
  actions: {
    flashError({ commit }, text) {
      commit('setSnackbar', { color: 'error', text });
    },
    flashSuccess({ commit }, text) {
      commit('setSnackbar', { color: 'success', text });
    },
    flashInfo({ commit }, text) {
      commit('setSnackbar', { color: 'info', text });
    },
  },
});
